module.exports = __webpack_public_path__ + "img/placeholder.1fc93ffb.jpg";